import {useCallback} from 'react';

import {$invoiceLinesHolder, updateInvoiceLinesHolder} from 'models/documents/invoices/create';

import {isStandartCategory} from '../helpers/consts';

const checkIfNumber = (values: string[], rowIndex: number, name: string) => {
    if (values.some((i) => i === undefined)) {
        updateInvoiceLinesHolder({
            index: rowIndex,
            data: {columnId: name, value: ''},
        });
        return false;
    }

    if (values.some((i) => isNaN(Number(i)))) {
        updateInvoiceLinesHolder({
            index: rowIndex,
            data: {columnId: name, value: ''},
        });
        return false;
    }

    return true;
};

export const useLineCalculations = () => {
    const combineValues = useCallback((rowIndex: number | undefined) => {
        if (rowIndex === undefined) {
            return;
        }
        const currentHolder = $invoiceLinesHolder.getState();
        const item = currentHolder[rowIndex];
        if (!item) {
            return;
        }
        const {qty, price} = item;
        const name = 'lines';

        if (!checkIfNumber([price.toString(), qty.toString()], rowIndex, name)) {
            return;
        }

        const multiplier = item.charges?.isCharge === 'true' ? 1 : -1;
        const xaf = item.charges?.amountXaf ? Number(item.charges.amountXaf) * multiplier : 0;
        const mutiplie = !price || !qty ? '' : (Number(price) * Number(qty) + xaf).toFixed(2);
        updateInvoiceLinesHolder({
            index: rowIndex,
            data: {columnId: name, value: mutiplie},
        });
    }, []);

    const calculateLineAmountWVat = useCallback(
        (rowIndex: number | undefined, columnId?: 'vatCategory' | 'vat') => {
            if (rowIndex === undefined) {
                return;
            }
            const currentHolder = $invoiceLinesHolder.getState();
            const item = currentHolder[rowIndex];
            if (!item) {
                return;
            }

            const {vat, lines, vatCategory} = item;
            const name = 'lineAmountWVat';

            if (columnId === 'vatCategory') {
                updateInvoiceLinesHolder({
                    index: rowIndex,
                    data: [
                        {
                            columnId: 'vat',
                            value: isStandartCategory(vatCategory?.value) ? '' : '0',
                        },
                        {
                            columnId: 'lineAmountWVat',
                            value: isStandartCategory(vatCategory?.value)
                                ? ''
                                : Number(lines).toFixed(2),
                        },
                    ],
                });
                return;
            }

            if (!checkIfNumber([vat], rowIndex, name)) {
                return;
            }

            const mutiplie =
                !lines || !vat
                    ? ''
                    : (Number(lines) + (Number(lines) * Number(vat)) / 100).toFixed(2);
            updateInvoiceLinesHolder({
                index: rowIndex,
                data: {columnId: name, value: mutiplie},
            });
        },
        [],
    );

    return {
        combineValues,
        calculateLineAmountWVat,
    };
};
